module.exports = __webpack_public_path__ + "img/edycja.6ab2f479.svg";